<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isUserMasterDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
        <template slot="siteIds">
          <el-cascader
            v-model="detailFormData.siteIds"
              :options="options"
              :props="props"
              clearable></el-cascader>
        </template>
        <template slot="password">
          <el-button size="small" type="primary" @click="resetPassword">重置密码</el-button>
        </template>
        <template slot="checkbox">
          <el-checkbox :true-label="1" :false-label="0" v-model="detailFormData.isHandleDelivery">投递扫码</el-checkbox>
          <el-checkbox :true-label="1" :false-label="0" v-model="detailFormData.isHandleOrder">订单核销</el-checkbox>
          <el-checkbox :true-label="1" :false-label="0" v-model="detailFormData.isHelpDelivery">垃圾代投</el-checkbox>
          <el-checkbox :true-label="1" :false-label="0" v-model="detailFormData.isHelpOrder">商品代换</el-checkbox>
        </template>
        <template slot="radio">
          <el-radio-group v-model="detailFormData.isAreaManager">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </template>
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserMasterEditPage',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formUpdateUrl: '/modules/userEmployees/userEmployeesUpdate',
      formAddUrl: '/modules/userEmployees/userEmployeesAdd',
      isSubmitLoading: false,
      props: { multiple: true, children: 'children', label: 'name', value: 'id', emitPath: false, expandTrigger: 'hover' },
      options: [],
      detailForm: {
        title: '新增站长',
        className: 'wt-section-long-content',
        elements: [
          { name: '账号',
            key: 'userName',
            type: 'text',
            required: true,
            disabled: false },
          { name: '密码',
            key: 'password',
            type: 'password',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 20, message: '姓名长度不能超过20', trigger: 'blur' }
            ] },
          { name: '站点',
            key: 'siteIds',
            type: 'custom',
            required: true,
            disabled: false },
          { name: '姓名',
            key: 'name',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 20, message: '姓名长度不能超过20', trigger: 'blur' }
            ] },
          { name: '手机号',
            key: 'phone',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 11, max: 11, message: '手机号格式不正确', trigger: 'blur' },
              { pattern: this.$wtValidator.ValidatorPhonePattern, message: '手机号格式不正确', trigger: 'blur' }
            ] },
          { name: '功能权限',
            key: 'checkbox',
            type: 'custom',
            required: false,
            disabled: false },
          { name: '是否有区域负责人权限',
            key: 'radio',
            type: 'custom',
            required: false,
            disabled: false }]
      },
      detailFormButtons: {
        title: '新增站长',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', hidden: this.componentType !== 'add', className: 'primary' },
          { name: '提交', key: 'EDIT', action: 'EDIT', hidden: this.componentType !== 'edit', className: 'primary' },
          { name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      checkList: []
    }
  },
  created() {
    this.siteTreeList()
    this.detailForm.title = this.componentType === 'edit' ? '编辑站长' : '新增站长'
    this.detailForm.elements[0].disabled = this.componentType === 'edit'
    if (this.componentType === 'edit') {
      this.detailForm.elements[1].type = 'custom'
      this.detailForm.elements[1].required = false
      if (this.detailFormData.siteList) {
        const siteIds = []
        for (const item of this.detailFormData.siteList) {
          siteIds.push(item.id)
        }
        this.detailFormData.siteIds = siteIds
      }
    } else {
      this.detailForm.elements[1].type = 'password'
    }
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onEdit()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAdd()
      }).catch(() => {
      })
    },
    onEdit() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdate()
      }).catch(() => {
      })
    },
    resetPassword() {
      this.detailForm.elements[1].type = 'password'
      this.detailForm.elements[1].required = true
    },
    requestAdd() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: this.getSaveData(),
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'refresh')
      })
    },
    requestUpdate() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: this.getSaveData(),
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'refresh')
      })
    },
    getSaveData() {
      const params = JSON.parse(JSON.stringify(this.detailFormData))
      params.communityId = ''
      for (const item of this.options) {
        if (item.siteResultList && !params.communityId) {
          for (const iitem of item.siteResultList) {
            if (params.siteIds.indexOf(iitem.id) > -1) {
              params.communityId = item.id
            }
          }
        }
      }
      return params
    },
    // 社区
    siteTreeList() {
      this.$api.siteManage.site.siteTreeListByOrg({
        isDeliveryEnabled: 0,
        type: 1
        // userId: this.componentType === 'edit' ? this.detailFormData.id : ''
      }).then(res => {
        this.options = res.data
      })
    }
  },
  computed: {
    ...mapState({
      isUserMasterDetailLoading: state => state.userMaster.isUserMasterDetailLoading,
      detailFormData: state => state.userMaster.userMasterDetailData
    })
  }
}
</script>

<style scoped>
.action-check-group {
  padding-left: 180px;
}
.action-check-group .el-checkbox {
  margin-bottom: 8px;
}
.el-cascader {
  width: 100%;
}
</style>
